var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-bulk-action-context"},[_c('i',{staticClass:"pi pi-info-circle create-bulk-action-context__icon"}),_c('div',[(_vm.text !== '')?_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }